import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: `/price-checker/`,
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "price-checker" */ '../pages/price-checker/price-checker-definition')
    ),
    chunkName: 'price-checker',
  },
];
